<script>
export default {
  name: "NoContentPlaceholderCustom",
  props: {
    text: {
      type: String,
      required: false,
      default: trans('general.messages.no_content')
    },
    image: {
      type: String,
      required: false,
      default: '/img/illustrations/search.png'
    }
  }
}
</script>

<template>
  <div class="text-center">
    <slot>
      <slot name="image" v-bind:image="image">
        <img :src="image" alt="No content" class="img-fluid mb-4" style="max-width: 20rem;">
      </slot>
      <slot name="text" v-bind:text="text"><h3>{{ text }}</h3></slot>
      <slot name="action"></slot>
    </slot>
  </div>
</template>
